/* eslint-disable quotes */

module.exports = {
  siteTitle: "0chain blockchain based storage", // Site title.
  siteTitleAlt: "0chain", // Alternative site title for SEO.
  siteLogo: "/icons/icon-512x512.png", // Logo used for SEO and manifest.
  siteUrl: "https://test0chain.netlify.app/", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: "0chain block storage backed with ZCN website", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml",
  siteFBAppID: "", // FB Application ID for using app insights
  googleTagManagerID: "", // GTM tracking ID.
  disqusShortname: "0chain", // Disqus shortname.
  userName: "0chain",
  userTwitter: "0chain",
  userLocation: "USA",
  userDescription:
    "0chain is a platform for storage based on blockchain backed with ZCN",
  copyright: "Copyright © 0chain.net 2021-2022 . All Rights Reserved.", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#00d1b2", // Used for setting manifest and progress theme colors.
  backgroundColor: "#ffffff", // Used for setting manifest background color.
  cookieConsent:
    "This website uses cookies which are used to collect anonymous information to improve your browsing experience and for analytics and metrics.", // @TODO Add GDPR Cookie Consent
};

//some comments
